export function isSurveyBlockedByMatchState({
  dashboardActiveSingleMatch,
  dashboardTournamentMatches,
  view,
  selectedTournamentStatus,
  myMatchStatus,
}) {
  const activeTournamentMatch = ["pending", "reported", "disputed"].includes(
    String(myMatchStatus || "").toLowerCase()
  );
  return Boolean(
    dashboardActiveSingleMatch ||
    (Array.isArray(dashboardTournamentMatches) && dashboardTournamentMatches.length > 0) ||
    (view === "DETAIL" && String(selectedTournamentStatus || "").toLowerCase() === "running") ||
    activeTournamentMatch
  );
}

export function canOpenSurveyPrompt({
  currentUid,
  loadingProfile,
  dueSurvey,
  surveyBusy,
  checkInFlight,
  sessionGuard,
  blockedByMatch,
  blockingModalOpen,
  priorityNotification,
  menuOpen,
  notificationsOpen,
}) {
  return Boolean(
    currentUid &&
    !loadingProfile &&
    !dueSurvey &&
    !surveyBusy &&
    !checkInFlight &&
    !sessionGuard &&
    !blockedByMatch &&
    !blockingModalOpen &&
    !priorityNotification &&
    !menuOpen &&
    !notificationsOpen
  );
}
